import Layout from '../../internal/Layout.vue'
import ServiceOrdersPage from './components/ServiceOrderTable/ServiceOrdersTable.vue'
import ManageServiceOrder from './components/ManageServiceOrder/ManageServiceOrder.vue'
import AddMultipleServiceOrder from './components/AddMultipleServiceOrder/addMultipleServiceOrder.vue'
import ExitAuthorization from './components/ExitAuthorization/ExitAuthorization.vue'
import ListServiceOrdersByEquipment from './components/ListServiceOrdersByEquipment/listServiceOrdersByEquipment.vue'

const ServiceOrdersRoutes = {
  component: Layout,
  children: [
    {
      name: 'serviceOrder',
      path: '/',
      component: ServiceOrdersPage,
      meta: {
        module: 'ordem_de_servico',
        requiresAuth: true,
        requiresMaster: true,
        requiresAdmin: true,
        requiresSupervisor: true,
        requiresOperator: true,
        requiresCoordOp: true,
        requiresCoordSector: true,
        requiresLaboratory: true,
      },
    },
    {
      name: 'newServiceOrder',
      path: '/newServiceOrder',
      component: ManageServiceOrder,
      meta: {
        module: 'ordem_de_servico',
        requiresAuth: true,
        requiresMaster: true,
        requiresAdmin: true,
        requiresSupervisor: true,
        requiresOperator: true,
        requiresCoordOp: false,
        requiresCoordSector: false,
        requiresLaboratory: true,
      },
    },
    {
      name: 'editServiceOrder',
      path: '/editServiceOrder/:serviceOrderId',
      component: ManageServiceOrder,
      props: true,
      meta: {
        module: 'ordem_de_servico',
        requiresAuth: true,
        requiresMaster: true,
        requiresAdmin: true,
        requiresSupervisor: true,
        requiresOperator: true,
        requiresCoordOp: true,
        requiresCoordSector: true,
        requiresLaboratory: true,
      },
    },
    {
      name: 'addMultiple',
      path: '/addMultiple',
      component: AddMultipleServiceOrder,
      props: true,
      meta: {
        module: 'ordem_de_servico',
        requiresAuth: true,
        requiresMaster: true,
        requiresAdmin: true,
        requiresSupervisor: true,
        requiresOperator: true,
        requiresCoordOp: false,
        requiresCoordSector: false,
        requiresLaboratory: true,
      },
    },
    {
      name: 'exitAuthorization',
      path: '/exitAuthorization',
      component: ExitAuthorization,
      meta: {
        module: 'ordem_de_servico',
        requiresAuth: true,
        requiresMaster: true,
        requiresAdmin: true,
        requiresSupervisor: true,
        requiresOperator: true,
        requiresCoordOp: false,
        requiresCoordSector: false,
        requiresLaboratory: true,
      },
    },
    {
      name: 'listServiceOrders',
      path: '/listServiceOrders',
      props: (route) => ({
        equipmentId: route.query.equipment,
        month: route.query.month,
        year: route.query.year,
        type: route.query.type,
        departmentId: route.query.departmentId,
      }),
      component: ListServiceOrdersByEquipment,
      meta: {
        module: 'ordem_de_servico',
        requiresAuth: true,
        requiresMaster: true,
        requiresAdmin: true,
        requiresSupervisor: true,
        requiresOperator: true,
        requiresCoordOp: true,
        requiresCoordSector: true,
        requiresLaboratory: true,
      },
    },
  ],
}

export default ServiceOrdersRoutes
